<template>
  <div class="page-footer">
    <Page :total="total"
          :page-size="pageSize"
          :page-size-opts="pageSizeOpts"
          :show-total="showTotal"
          :show-sizer="showSizer"
          @on-change="changePage"
          @on-page-size-change="changePageSize"/>
  </div>
</template>

<script>
  export default {
    name: "page-footer",
    props: {
      pageSize: {
        type: Number,
        default: 50
      },
      total: {
        type: Number,
        default: 0
      },
      pageSizeOpts: {
        type: Array,
        default() {
          return [20, 50, 100]
        }
      },
      showTotal: Boolean,
      showSizer: Boolean
    },
    methods: {
      changePage(index) {
        this.$emit('on-change', index)
      },
      changePageSize(pageSize) {
        this.$emit('on-page-size-change', pageSize)
      }
    }
  }
</script>

<style scoped>
  .page-footer {
    padding: 15px;
    margin-top: 20px;
    background: #FFF;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/my-components/page-footer/page-footer.vue